import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {

  private maintenanceMode = false;
  private allowedEmails: string[] = [];

  constructor() {
    if (environment.maintenanceMode !== undefined) {
      this.maintenanceMode = environment.maintenanceMode;
    }
    if (environment.maintenanceEmails !== undefined) {
      this.allowedEmails = environment.maintenanceEmails;
    }
  }

  /**
   * Activate maintenance mode on demand
   */
  public enableMaintenanceMode(): void {
    this.maintenanceMode = true;
  }

  /**
   * Deactivate maintenance mode on demand
   */
  public disableMaintenanceMode(): void {
    this.maintenanceMode = false;
  }

  /**
   * Set the list of email addresses allowed to bypass maintenance
   * @param emails Array of email addresses
   */
  public setAllowedEmails(emails: string[]): void {
    this.allowedEmails = emails || [];
  }

  /**
   * Determines if the maintenance component should be displayed for the given user
   * @param user Current user or undefined
   * @returns true if the maintenance component should be displayed, false otherwise
   */
  public shouldShowMaintenance(user: any): boolean {
    if (!this.maintenanceMode) {
      return false;
    }

    if (!user || !user.mail || user.mail.length === 0) {
      return true;
    }

    const userEmail = user.mail[0].toLowerCase();
    const isAllowed = this.allowedEmails.some(
      (email) => email.toLowerCase() === userEmail,
    );

    return !isAllowed;
  }
}
